import React from 'react';
import { Link } from "react-router-dom";

class QuickLink extends React.Component {
  
    render() {
      if (this.props.type === "internal") {
        return(
            <Link to={this.props.link} style={{textDecoration: 'none', textAlign: "left"}}>
              <div className="quickLink">
                {this.props.text}
              </div>
            </Link>
        );  
      }
      else {
        return(
            <a href={this.props.link} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', textAlign: "left"}}>
              <div className="quickLink">
                {this.props.text}
              </div>
            </a>
        );
      }
    }
}

export default QuickLink